export default "__VITE_ASSET__b002c0e8__"